import { Directive, ElementRef, Input } from '@angular/core';
import { LSCreenSize, ScreenUtilsService } from 'core/services';
import { combineLatest, map, Subject, takeUntil } from 'rxjs';

@Directive({
  selector: '[screenSizeClasses]',
  standalone: true,
})
export class ScreenSizeClassesDirective {

  readonly #destroy = new Subject<void>()

  readonly #checkSubject = new Subject<void>()
  @Input('screenSizeClasses')
  screenSizeClasses: Partial<Record<LSCreenSize, string[]>>

  readonly screenSizeSubject = this._screenUtilsService.screenSizeSubject;

  constructor(
    private readonly _screenUtilsService: ScreenUtilsService,
    private readonly _elementRef: ElementRef<HTMLElement>
  ) { }



  ngAfterViewInit() {


    combineLatest([this.#checkSubject, this.screenSizeSubject]).pipe(
      map(([, screenSize]) => screenSize),
      takeUntil(this.#destroy)
    )
      .subscribe((screenSize) => {
        if (!this.screenSizeClasses) {
          return;
        }

        Object.entries(this.screenSizeClasses).forEach(([screenSizeInner, classList]: [LSCreenSize, string[]]) => {

          classList.forEach((className) => {
            this._elementRef.nativeElement.classList.toggle(className, screenSizeInner === screenSize);
          })
        })

      })
  }

  ngDoCheck() {
    this.#checkSubject.next();
  }


  ngOnDestroy() {
    this.#checkSubject.next();
    this.#destroy.next()
    this.#destroy.complete()
  }

}
